import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledExportBulletinContent = styled('div')(
  () => css`
    .field-label {
      font-size: 0.75rem;
      font-weight: 700;
      line-height: 1.5rem;
      margin-bottom: 8px;
      display: block;
    }

    .field-group {
      margin-bottom: 16px;
    }

    .max-count-hint {
      font-size: 0.625rem;
      color: #f16063;
      margin-top: 4px;
    }

    .create-bulletin-link {
      margin-top: 0;
      padding: 0;
      border: none;
      background: none;
      display: inline-block !important;
      font-size: 0.75rem;
      font-weight: 700;
      color: #199da3;
      text-align: right;

      &:hover {
        text-decoration: underline;
        background: none;
      }
    }
  `
);
